<template>
  <div class="card-container">
    <b-card class="alert-detail-box">
      <b-row>
        <b-col>
          <b-button
            class="float-right mt-n1 p-0 mr-n1"
            @click="$emit('close')"
            variant="flat-primary"
            v-if="indexPre !== 0"
          >
            <b-icon icon="x" font-scale="2" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div>
            <h4>
              <b-icon icon="stars" />
              AI Generated
            </h4>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!hasData">
        <b-col>
          <div class="text-center my-2">
            <b-spinner small type="grow" label="Loading..." />
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div>
            <h5>Explanation:</h5>
            <p>
              {{ aiResponse.explanation || "No explanation provided." }}
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="hasData && aiResponse.suggestions && aiResponse.suggestions.length">
        <b-col>
          <div>
            <h5>Suggestions:</h5>
            <ul class="mt-1">
               <li v-for="(item, index) in aiResponse.suggestions" :key="index" class="ml-n2">
                {{ item }}
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    alertId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      aiResponse: {},
      loaded: false,
    };
  },
  computed: {
    alertSuggestionsUrl() {
      return `/alerts/${this.alertId}/suggestions.json`;
    },
    hasData() {
      return this.loaded;
    },
  },
  mounted() {
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.alertSuggestionsUrl, {
          params: {},
        })
        .catch(() => {
          this.aiResponse = {};
        })
        .then((response) => { this.aiResponse = response.data; })
        .finally(() => {
          this.loaded = true;
        });
    },
  },
};
</script>
<style scoped>
.card-container {
  justify-content: center;
  align-items: center;
  padding-bottom: 3%;
}

.alert-detail-box {
  max-width: 800px; /* Adjust the width to your desired size */
  width: 100%; /* Ensures responsiveness */
  margin: 0 auto; /* Centers the card */
}
</style>
